import React, { useRef } from "react";
import styles from "./GridColumn.module.css";
import { PROGRAMME_GRID_VIEW_HOUR_HEIGHT } from "../ProgrammeGridView";

function GridColumn({
  columnData,
  eventsHours,
  handleMouseEnter,
  handleMouseLeave,
}) {
  const [startHour, endHour] = eventsHours;
  if (!startHour || !endHour) {
    return <></>;
  }
  const fullHeight =
    (endHour - startHour + 1) * PROGRAMME_GRID_VIEW_HOUR_HEIGHT;
  const dividersArray = new Array((endHour - startHour + 1) * 4).fill(0);

  if (columnData.length === 0) {
    return (
      <div
        className={styles.emptyColumn}
        style={{ minHeight: `${fullHeight}px` }}
      >
        {dividersArray.map((divider) => (
          <div className={styles.divider}></div>
        ))}
      </div>
    );
  }

  columnData.sort((a, b) => {
    const aStartTime = new Date(a.startDateTime);
    const bStartTime = new Date(b.startDateTime);
    const dif = aStartTime - bStartTime;
    return dif == 0 ? b.order.localeCompare(a.order) : dif;
  });
  //CONTAR ITEMS "REPETIDOS" mismo start y end time
  const freqMap = {};
  columnData.forEach((item) => {
    const { startDateTime, endDateTime } = item;
    const key = `${startDateTime}-${endDateTime}`;
    freqMap[key] = freqMap[key] ? freqMap[key] + 1 : 1;
  });
  //tomar los items que su frecuencia sea mayor a 1
  const overlappingMergedItems = {};
  const mergedData = columnData
    .map((item) => {
      const completeActivity = JSON.parse(JSON.stringify(item));
      const { startDateTime, endDateTime } = completeActivity;
      const key = `${startDateTime}-${endDateTime}`;
      const hasOverlapping = freqMap[key] > 1;
      const alreadyMerged = overlappingMergedItems[key];
      if (alreadyMerged) return null;
      if (hasOverlapping) {
        const overlappingActivities = columnData.filter(
          (activity) =>
            activity.startDateTime === startDateTime &&
            activity.endDateTime === endDateTime
        );
        completeActivity.overlappingActivities = overlappingActivities;
        overlappingMergedItems[key] = true;
        return completeActivity;
      }
      return item;
    })
    .filter((item) => !!item);

  const firstActivity = mergedData[0];
  const { startDateTime } = firstActivity;
  const startHourNumeric =
    Number(startDateTime.split("T")[1].split(":")[0]) +
    Number(startDateTime.split("T")[1].split(":")[1]) / 60;
  const emptySpanTillStart = startHourNumeric - eventsHours[0];
  const emptySpanTillStartHeight =
    emptySpanTillStart * PROGRAMME_GRID_VIEW_HOUR_HEIGHT;

  return (
    <div className={styles.activityGridColumn}>
      <div className={styles.dividerContainer}>
        {dividersArray.map((divider, index) => (
          <Divider index={index} key={`divider_index_${index}`} />
        ))}
      </div>
      <div className={styles.activitiesContainer}>
        <div style={{ minHeight: `${emptySpanTillStartHeight}px` }} />
        {mergedData.map((activity, index) => (
          <GridActivityItem
            key={`activity_card_${activity.id}`}
            itemData={activity}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            allColumActivities={mergedData}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}

export default GridColumn;

function GridActivityItem({
  itemData,
  allColumActivities,
  index,
  handleMouseEnter,
  handleMouseLeave,
}) {
  const ref = useRef(null);
  const {
    startDateTime,
    endDateTime,
    title,
    activityTrackColor,
    activityTypeColor,
    overlappingActivities,
  } = itemData;
  const appConfiguration = JSON.parse(window.localStorage.getItem("MMJson"));
  const { useSessionTypeColorAsBackgroundInSessionViewList } = appConfiguration;
  const backgroundColor = useSessionTypeColorAsBackgroundInSessionViewList
    ? activityTypeColor
    : activityTrackColor;
  const backgroundColorToUse = activityTypeColor;
  const startTime = new Date(startDateTime);
  const endTime = new Date(endDateTime);
  const duration = endTime - startTime;
  const activityHeight = (duration / 3600000) * PROGRAMME_GRID_VIEW_HOUR_HEIGHT;
  const startTimeStr = startDateTime
    .split("T")[1]
    .split(":")
    .splice(0, 2)
    .join(":");
  const endTimeStr = endDateTime
    .split("T")[1]
    .split(":")
    .splice(0, 2)
    .join(":");
  const isBGColorLight = isColorLight(backgroundColor);
  const isValidBackground =
    backgroundColor && backgroundColor !== "transparent";
  const cardStyles = {
    backgroundColor: isValidBackground ? backgroundColor : "#FFFFFF",
    color: isValidBackground
      ? isBGColorLight
        ? "#000000"
        : "#FFFFFF"
      : "#000000",
  };
  let emptyTimeTillNextActivityHeight = 0;

  const nextActivity = allColumActivities[index + 1];
  if (nextActivity) {
    const nextStartTimeString = nextActivity.startDateTime;
    const nextStartTime = new Date(nextStartTimeString);
    const emptyTimeTillNextActivity = nextStartTime - endTime;
    emptyTimeTillNextActivityHeight =
      (emptyTimeTillNextActivity / 3600000) * PROGRAMME_GRID_VIEW_HOUR_HEIGHT;
  }

  function handleToolTipOpening(itemDataToDisplay) {
    itemDataToDisplay.callerPosition = ref.current.getBoundingClientRect();
    handleMouseEnter(itemDataToDisplay);
  }

  const hasEnoughHeight = activityHeight >= PROGRAMME_GRID_VIEW_HOUR_HEIGHT / 3;
  let renderedTitle = title;
  if (!hasEnoughHeight && title.length > 50) {
    renderedTitle = `${title.slice(0, 50)}...`;
  }

  return (
    <>
      <div
        className={styles.activityGridItemWrapper}
        style={{
          minHeight: `${activityHeight}px`,
          maxHeight: `${activityHeight}px`,
        }}
        ref={ref}
      >
        <div
          className={
            hasEnoughHeight
              ? styles.activityGridItem
              : styles.smallActivityGridItem
          }
          style={{
            ...cardStyles,
            ...{ borderLeft: "14px solid " + backgroundColorToUse },
          }}
          onClick={
            overlappingActivities
              ? () => {}
              : () => handleToolTipOpening(itemData)
          }
        >
          {hasEnoughHeight && <span>{`${startTimeStr} - ${endTimeStr}`}</span>}
          {!overlappingActivities && <span>{renderedTitle}</span>}
          {overlappingActivities && (
            <div  className={styles.rowSharingPresentationBox}>
              {overlappingActivities.map((activity) => {
                let titleToRender = activity.title;
                if (!hasEnoughHeight && titleToRender.length > 50) {
                  titleToRender = `${titleToRender.slice(0, 50)}...`;
                }
                return (
                  <div
                    className={styles.rowSharingPresentation}
                    style={{
                      height: `${
                        activityHeight - 40 / overlappingActivities.length
                      }`,
                      overflow: "hidden",
                    }}
                    onClick={() => handleToolTipOpening(activity)}
                  >
                    <span>{titleToRender}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          minHeight: `${emptyTimeTillNextActivityHeight}px`,
          maxHeight: `${emptyTimeTillNextActivityHeight}px`,
        }}
      ></div>
    </>
  );
}

function Divider({ index }) {
  return (
    <div
      className={(index + 1) % 4 === 0 ? styles.strongDivider : styles.divider}
    ></div>
  );
}

function isColorLight(color) {
  // Ensure the color is in the format "#RRGGBB"
  color = color.replace("#", "");

  // Convert the hex color to RGB
  let r = parseInt(color.slice(0, 2), 16);
  let g = parseInt(color.slice(2, 4), 16);
  let b = parseInt(color.slice(4, 6), 16);

  // Calculate luminance
  let luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // Check if the color is light or dark
  return luminance > 160; // Adjust the threshold as needed
}
